import React, { useState } from "react";
import Header from "../Header";
import Footer from "../Footer";
import GeneralRules from "../GeneralRules";
import ConditionsForParticipation from "../ConditionsForParticipation";
import GRDuringTheCompetition from "../GRDuringTheCompetition";
import Competition from "../Competition";
import ScheduleTable from "../ScheduleTable";
import RaceWhere from "../RaceWhere";
import StatsSection from "../StatsSection";

const AboutTheRace = () => {
  return (
    <div>
      <Header />
      {/* <Card /> */}
      <RaceWhere />
      <ScheduleTable />
      <GeneralRules />
      <ConditionsForParticipation />
      <GRDuringTheCompetition />
      <Competition />
      <StatsSection />
      <Footer />
    </div>
  );
};

export default AboutTheRace;
